export default __webpack_public_path__ + "static/media/wmlWebsitePreview.82e8b95d.jpg";